<template>
    <!-- BEGIN: Content-->
    <div class="permissionList">
      <v-container fluid>

        <v-row>
          <v-col md="12" sm="12" class="d-flex" style="justify-content:space-between">
            <v-breadcrumbs
              :items="breadcrumbs"
              divider="/"
            ></v-breadcrumbs>

            <v-btn
              color="#000000"
              class="white--text"
              depressed
              @click.stop="dialog = true"
            >
              Permission
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>

          </v-col>
        </v-row>

        <v-row>
          <v-col md="12" sm="12">
            <v-card class="card-shadow py-3">
              <v-data-table
                dense
                :headers="fields"
                :items="permission"
                class="elevation-0"
                loading="false"
                loading-text="Loading... Please wait"
              >
                <template v-slot:item.#="{ item }">
                  {{ item.created_at }}
                </template>
                <template v-slot:item.name="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editType(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteItem(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <!-- add user dialog -->
      <v-dialog
        v-model="dialog"
        max-width="600px"
      >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add Permission</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      label="Permission*"
                      v-model="item.permission"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="create"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- end user -->

      <!-- user update modal-->
      <v-dialog
        v-model="updatedialog"
        max-width="600px"
      >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Update Permission</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      label="Permission*"
                      v-model="item.updatepermission"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="updatedialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="update"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update user -->

    </div>

</template>

<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import {ability} from '../../services/ability'

export default {
    name:"permissionList",
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          updatedialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'User Config',
              disabled: false,
              href: '',
            },
            {
              text: 'Permissions',
              disabled: false,
              href: '',
            },
          ],
          fields: [
             {
              text: '#',
              align: 'start',
              value: 'created_at',
            },
            { text: 'Name', value: 'name' },
            { text: 'Action', value: 'action' },
           ],
          item:{
                permission:"",
                updatepermission: "",
                updateID: "",
                _method:"patch"
            },
            loading: false,
           disabled: false,
           permission: [],
           isBusy: false,
            updateModal: null
        }
    },
    beforeMount() {
      if(!ability.can('user-management', 'all')) {
        this.$router.push({ name: 'Pos' })
        return
      }
    },
    mounted(){
      this.getPermission()
    },
    methods:{
      async getPermission(){
        this.isBusy = true
        await axios.get('/permission').then(response=>{
            this.isBusy = false
            this.permission = response.data.permission
        }).catch(error=>{
            console.log(error)
            this.isBusy = false
        })
      },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('permission',this.item.permission)

            await axios.post('/permission', fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              this.res = response.data.status
              if(this.res === parseInt(200))
                this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                this.getPermission()
                this.clear()
              this.item.permission = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

        }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('permission',this.item.updatepermission)
            fd.append('_method',this.item._method)

            await axios.post(`/permission/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              this.res = response.data.status
              if(this.res === parseInt(200))
                this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                this.updatedialog = false
                this.getPermission()
              this.item.updatepermission = ''
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async editType(id) {
        let index = this.permission.filter(item => item.id === id );
        this.item.updatepermission = index[0].name
        this.item.updateID = index[0].id
        this.updatedialog = true
      },
      deleteItem(id){
            if(confirm("Are you sure to delete permission ?")){
                axios.delete(`/permission/${id}`).then(response=>{
                  this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                    this.getPermission()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }

    }
}
</script>